export let GtkmActionTypes;
(function (GtkmActionTypes) {
  GtkmActionTypes["SetAnimationStart"] = "[Gtkm] Set Animation Start";
  GtkmActionTypes["SetAnimationStop"] = "[Gtkm] Set Animation Stop";
  GtkmActionTypes["SetShowingErrorModal"] = "[Gtkm] Set Showing Error Modal";
  GtkmActionTypes["SetAnimationNotDisplayed"] = "[Gtkm] Set Animation Not Displayed";
  GtkmActionTypes["SetAnimationShowingCount"] = "[Gtkm] Set Animation Showing Count";
  GtkmActionTypes["SetHasDomainChangedInDomainStep"] = "[Gtkm] Set Has Domain Changed In Domain Step";
})(GtkmActionTypes || (GtkmActionTypes = {}));